import React, { useEffect,useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import LoginService from "../../../services/auth-service.js";
import { useNavigate } from 'react-router-dom';
const CountdownTimer = ({ initialSeconds, onTimeout }) => {
  const [secondsRemaining, setSecondsRemaining] = useState(initialSeconds);

  useEffect(() => {
    if (secondsRemaining > 0) {
      const timer = setTimeout(() => {
        setSecondsRemaining(prevSeconds => prevSeconds - 1);
      }, 1000);

      return () => clearTimeout(timer);
    } else {
      onTimeout(); // Call the callback function when the timer reaches 0
    }
  }, [secondsRemaining, onTimeout]);

  return (
    <h6>You will be logged out in {secondsRemaining} seconds.</h6>
  );
};
const Alert = (props) => {
  const navigate = useNavigate();
  const handleLogout = () => {
    // Perform logout action
   LoginService.deleteAccessToken();
   navigate('/')
   
  };
    return (
      <>
       <Modal  {...props}>
        <Modal.Header >
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        {/* <div id="success">
              <h5 style={{color:'green'}}> Password changed successfully.</h5>  
          </div> */}
        <CountdownTimer initialSeconds={10} onTimeout={handleLogout} />
            
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={props.onHide}>
            Close
          </Button>
          
        </Modal.Footer> */}
      </Modal>
      </>
    );
  }
  


  export default Alert;



